import { Link } from "react-router-dom";
import { H3, Image, P } from "../../../../AbstractElements";
import { OldReisTelephone } from "../../../../Constant";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const TrackeOrderBox = () => {
  return (
    <div className="order-box">
      <div className="d-flex">
        <div className="flex-shrink-0">
          <Image src={dynamicImage("dashboard-2/total-icon/headphones.png")} alt="" />
        </div>
        <div className="flex-grow-1">
          <Link to={`${process.env.PUBLIC_URL}/chat/chat`}>
            <H3>{OldReisTelephone}</H3>
            <P>Sold by Vingate Techies</P>
            <P>#BK739200</P>
          </Link>
        </div>
        <span>$30</span>
      </div>
    </div>
  );
};
